import React, { FC } from 'react';

import { Flex } from '@rover/kibble/core';
import NotificationsCenterList from '@rover/react-lib/src/components/notifications/NotificationsCenterList/NotificationsCenterList';

import NotificationsCenterDropdown from './NotificationsCenterDropdown';
import NotificationsCenterToggle from './NotificationsCenterToggle';
import NotificationsCenterToggleMobile from './NotificationsCenterToggleMobile';

type Props = {
  unreadCountDisplay?: string;
  handleButtonClick: () => void;
  isOpen: boolean;
  buttonRef: React.MutableRefObject<HTMLButtonElement | null>;
  isMobileBreakpoint?: boolean;
  implementDjangoHacks: boolean;
};

const NotificationsCenter: FC<Props> = ({
  unreadCountDisplay,
  handleButtonClick,
  isOpen,
  buttonRef,
  isMobileBreakpoint,
  implementDjangoHacks,
}) => {
  return (
    <Flex
      position={['static', 'static', 'relative']}
      alignSelf="stretch"
      alignItems="center"
      minWidth="min-content"
    >
      <NotificationsCenterToggle
        unreadCountDisplay={unreadCountDisplay}
        handleButtonClick={handleButtonClick}
        isOpen={isOpen}
        buttonRef={buttonRef}
        implementDjangoHacks={implementDjangoHacks}
        display={implementDjangoHacks ? ['none', 'inline-block'] : ['none', 'none', 'inline-block']}
      />
      <NotificationsCenterToggleMobile
        unreadCountDisplay={unreadCountDisplay}
        handleButtonClick={handleButtonClick}
        buttonRef={buttonRef}
        implementDjangoHacks={implementDjangoHacks}
        display={
          implementDjangoHacks
            ? ['inline-block', 'none', 'none']
            : ['inline-block', 'inline-block', 'none']
        }
      />
      <NotificationsCenterDropdown isOpen={isOpen} implementDjangoHacks={implementDjangoHacks}>
        {isOpen && <NotificationsCenterList isMobileBreakpoint={isMobileBreakpoint} />}
      </NotificationsCenterDropdown>
    </Flex>
  );
};

export default NotificationsCenter;
